// WARNING: Do NOT edit this file outside npm-helsecore, it will be reset on build!

import type { FrontpageCardsProps } from "@dip/helsecore/src/components/parts/FrontpageCards/FrontpageCards.d";
import { FrontpageCards } from  "@dip/helsecore/src/components/parts/FrontpageCards/FrontpageCards"
import React from 'react';

export default function (props: Readonly<FrontpageCardsProps>): React.JSX.Element {
  return <FrontpageCards {...props} />;
}
